import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getWorkspaceTokens } from './workspaceStyles';
import {
  buildMobileFrameHeight,
  resolveResponsiveMinHeight,
} from './workspaceResponsiveSizing';

function AnalyticsGridFrame({
  children,
  fill = true,
  minHeight,
  sx,
  style,
}) {
  const theme = useTheme();
  const tokens = getWorkspaceTokens(theme);
  const resolvedMinHeight = resolveResponsiveMinHeight(minHeight, tokens.objectMinHeight.table);
  const frameHeight = buildMobileFrameHeight(resolvedMinHeight, tokens.objectMinHeight.table);

  return (
    <Box
      data-testid="analytics-grid-frame"
      data-frame-height={JSON.stringify(frameHeight)}
      data-min-height={JSON.stringify(resolvedMinHeight)}
      style={style}
      sx={{
        width: '100%',
        height: fill ? frameHeight : undefined,
        maxHeight: fill ? { xs: 'none', md: '100%' } : undefined,
        minWidth: 0,
        minHeight: resolvedMinHeight,
        flex: fill ? { xs: '0 0 auto', md: '1 1 0' } : '0 1 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: `${tokens.radius}px`,
        boxShadow: theme.palette.mode === 'light'
          ? theme.shadows[3]
          : '0 1px 2px rgba(0, 0, 0, 0.35), 0 12px 28px rgba(0, 0, 0, 0.32)',
        overflow: 'hidden',
        '& > *': {
          minWidth: 0,
          minHeight: 0,
          flex: fill ? { xs: '1 1 0', md: '1 1 0' } : '0 1 auto',
        },
        '& > .MuiPaper-root': {
          boxShadow: 'none',
          borderRadius: 'inherit',
          overflow: 'hidden',
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export default AnalyticsGridFrame;
